import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    secondDomain: "",
    AccessId: "",
    AccessKey: ""
  },
  getters: {
  },
  mutations: {
    setSecondDomain(state, value){
      state.secondDomain = value
    },
    setAccessId(state, value){
      state.AccessId = value
    },
    setAccessKey(state, value){
      state.AccessKey = value
    }
  },
  actions: {
  },
  modules: {
  }
})
